
import React from 'react';
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";
import { SettingsSectionProps } from '../types';

const ToggleSettings = ({ localSettings, setLocalSettings }: SettingsSectionProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between space-x-2">
        <div className="flex items-center gap-2">
          <Label htmlFor="tutorialEnabled">Tutorial Tips</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <HelpCircle className="h-4 w-4 text-muted-foreground" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Show helpful tips during gameplay</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Switch
          id="tutorialEnabled"
          checked={localSettings.tutorialEnabled}
          onCheckedChange={(checked) =>
            setLocalSettings({
              ...localSettings,
              tutorialEnabled: checked
            })
          }
        />
      </div>
      
      <div className="flex items-center justify-between space-x-2">
        <div className="flex items-center gap-2">
          <Label htmlFor="autoSave">Auto Save</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <HelpCircle className="h-4 w-4 text-muted-foreground" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Automatically save your progress</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Switch
          id="autoSave"
          checked={localSettings.autoSave}
          onCheckedChange={(checked) =>
            setLocalSettings({
              ...localSettings,
              autoSave: checked
            })
          }
        />
      </div>
      
      <div className="flex items-center justify-between space-x-2">
        <div className="flex items-center gap-2">
          <Label htmlFor="soundEnabled">Sound Effects</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <HelpCircle className="h-4 w-4 text-muted-foreground" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Enable game sound effects</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Switch
          id="soundEnabled"
          checked={localSettings.soundEnabled}
          onCheckedChange={(checked) =>
            setLocalSettings({
              ...localSettings,
              soundEnabled: checked
            })
          }
        />
      </div>
    </div>
  );
};

export default ToggleSettings;
